import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  AppBar,
  Toolbar,
  CssBaseline,
  useScrollTrigger,
  Slide,
  Typography,
  Grid,
  Hidden,
  Box,
  Button,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

//actions
import { logout, tryLogin } from '../../redux/actions/authActions';

const useStyles = makeStyles((theme) => ({
  paddingHeader: {
    padding: '10px',
    background: '#01579b',
    color: '#ffffff',
  },
  title: {
    flexGrow: 1,
  },
  divMenu: {
    position: 'absolute',
    width: 150,
    right: 5,
    top: 25,
    textAlign: 'center',
  },
  divMenuXs: {
    position: 'absolute',
    width: 150,
    right: 5,
    top: 10,
    textAlign: 'right',
  },
  boxTitle: {
    width: '85%',
    float: 'left',
  },
  divHeader: {
    display: 'inline',
  },

  logos: {
    width: '80%',
  },
}));

function HideOnScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({ target: window ? window() : undefined });

  return (
    <Slide appear={false} direction='down' in={!trigger}>
      {children}
    </Slide>
  );
}

HideOnScroll.propTypes = {
  children: PropTypes.element.isRequired,
  window: PropTypes.func,
};

const HideAppBar = (props) => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.usuario);

  // const [anchorEl, setAnchorEl] = useState(null);
  // const open = Boolean(anchorEl);

  // const handleMenu = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  const handLogOut = () => {
    dispatch(logout());
    // setAnchorEl(null);
  };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  useEffect(() => {
    dispatch(tryLogin());
  }, [dispatch]);

  return (
    <Fragment>
      <CssBaseline />
      <HideOnScroll {...props}>
        <AppBar bgcolor='primary.main' className={classes.paddingHeader}>
          <div className={classes.divHeader}>
            <Grid container spacing={1}>
              <Grid item xs={11}>
                <Box className={classes.boxTitle} xs={8} md={11}>
                  <Typography variant='h5' className={classes.title}>
                    Trenes Argentinos
                  </Typography>
                  <Hidden xsDown>
                    <Typography variant='h6' className={classes.title}>
                      Reservá tu tren
                    </Typography>
                  </Hidden>
                  {/* <img
                  src='/img/logo-trenes.png'
                  className={classes.logos}
                  alt='Ope-ferroviaria'
                /> */}
                </Box>
              </Grid>
              <Grid item xs={1} style={{ textAlign: 'right' }}>
                {user && (
                  <>
                    <Hidden xsDown>
                      <div className={classes.divMenu}>
                        <Button onClick={handLogOut} variant='outlined' color='inherit'>
                          Cerrar sesión
                        </Button>
                      </div>
                    </Hidden>
                    <Box display={{ xs: 'block', sm: 'none' }}>
                      <div className={classes.divMenuXs}>
                        <Button onClick={handLogOut} color='inherit'>
                          <ExitToAppIcon />
                        </Button>
                      </div>
                    </Box>
                  </>
                )}
              </Grid>
            </Grid>
          </div>
        </AppBar>
      </HideOnScroll>
      <Toolbar />
    </Fragment>
  );
};

export default HideAppBar;
